import TabSection from '../TabSection';
import CompanyFields from './CompanyFields';
import LocationFields from './LocationFields';
import ResourceFields from './ResourceFields';

const AccountTab = () => {
  return (
    <TabSection title="Account">
      <CompanyFields />
      <LocationFields />
      <ResourceFields />
    </TabSection>
  );
};

export default AccountTab;
